import {
  FLOWS_VINCULATION_FILTER,
  FLOWS_VINCULATION_FILTER_ERROR,
  STATUS_VINCULATION_FILTER,
  STATUS_VINCULATION_FILTER_ERROR,
  TYPE_VINCULATION_FILTER,
  TYPE_VINCULATION_FILTER_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Filtro Flujo - Action

export const flowsVinculationFilterAction = () => async (dispatch) => {
  try {
    const response = await axiosTokenInstance.get(`/api/reports/linked-up/flows`, {
      withApiKey: true,
    });
    const { data, status } = response || {};
    dispatch({
      type: FLOWS_VINCULATION_FILTER,
      payload: data || [],
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: FLOWS_VINCULATION_FILTER_ERROR,
      payload: e || {},
    });
  }
};

// Filtro Status - Action
export const statusVinculationFilterAction = () => async (dispatch) => {
  try {
    const response = await axiosTokenInstance.get(`/api/reports/linked-up/status`, {
      withApiKey: true,
    });
    const { data, status } = response || {};
    dispatch({
      type: STATUS_VINCULATION_FILTER,
      payload: data || [],
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: STATUS_VINCULATION_FILTER_ERROR,
      payload: e || {},
    });
  }
};

// Filtro Tipo - Action
export const typeVinculationFilterAction = () => async (dispatch) => {
  try {
    const response = await axiosTokenInstance.get(`/api/reports/linked-up/types`, {
      withApiKey: true,
    });
    const { data, status } = response || {};
    dispatch({
      type: TYPE_VINCULATION_FILTER,
      payload: data || [],
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: TYPE_VINCULATION_FILTER_ERROR,
      payload: e || {},
    });
  }
};
